import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({ providedIn: 'root' })
export class ApiConfigService {
    readonly baseUrl = environment.apiUrl;
    readonly authUrl = environment.authUrl;

    auth(path: string): string {
        const base = this.authUrl.replace(/\/+$/, '');
        const p = path.replace(/^\/+/, '');
        return `${base}/${p}`;
    }

    url(path: string): string {
        const base = this.baseUrl.replace(/\/+$/, '');
        const p = path.replace(/^\/+/, '');
        return `${base}/${p}`;
    }
}